import { render, staticRenderFns } from "./MapEpicenter.component.vue?vue&type=template&id=0a2a8ab7"
import script from "./MapEpicenter.component.vue?vue&type=script&lang=ts"
export * from "./MapEpicenter.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports